/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  DeleteExerciseMutationResponse,
  DeleteExercisePathParams,
  DeleteExercise401,
  DeleteExercise403,
  DeleteExercise404,
} from '../types/DeleteExercise.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getDeleteExerciseUrl(id: DeleteExercisePathParams['id']) {
  const res = { method: 'DELETE', url: `/exercises/${id}` as const };
  return res;
}

/**
 * @summary Delete exercise
 * {@link /exercises/:id}
 */
export async function deleteExercise(id: DeleteExercisePathParams['id'], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteExerciseMutationResponse,
    ResponseErrorConfig<DeleteExercise401 | DeleteExercise403 | DeleteExercise404>,
    unknown
  >({ method: 'DELETE', url: getDeleteExerciseUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
